/** Rows per page of the adjustments table. */
export const COMPENSATION_TABLE_PAGE_SIZE = 15;

/** A manually entered increase percentage is clamped to this ceiling; a computed percentage may
 * exceed it and is only flagged (`exceedsIndividualCap`), never truncated. */
export const MAX_INDIVIDUAL_INCREASE_PERCENT = 30;
